export const Colors = {
  black: "#010304",
  white: "#ffffff",
  cyan: "#26DDF9",
  light_grey: "#F5F5F5",
  light_grey_card: "#F4F4F4",
  black_body_secondary: "#171717",
  black_secondary: "#000000",
  black_display_secondary: "#1D1D1F",
  black_Card_small_text: "#0F0F0F",
  skyBlue: "#26ddf9",
  black_Card_SubTitle: "#002930",
  pink: "#E1D6FF",
  cyan_hover: "#7CEAFB",
  cyan_active: "#A8F1FC",
  gray: {
    "900": "#1A1C1D",
    "800": "#343536",
    "700": "#4D4F4F",
    "600": "#676868",
    "500": "#808181",
    "400": "#999A9B",
    "300": "#B3B3B4",
    "200": "#CCCDCD",
    "100": "#E6E6E6",
    "50": "#F7F7F7",
    "40": "#E2E2E2"
  },
  green: {
    "600": "#0E8535",
    "500": "#11A642",
    "100": "#CFEDD9",
    "50": "#F3FBF5"
  },
  red: {
    "600": "#CA3A3A",
    "500": "#FC4848",
    "100": "#FEDADA",
    "50": "#FFF6F6"
  },
  yellow: {
    "500": "#F59E00",
    "50": "#FEFAF2"
  },
  blue: {
    "500": "#005CF0",
    "50": "#F2F7FE"
  }
} as const;
